import { render } from "./milestone-carousel.vue?vue&type=template&id=1ff765d0&scoped=true&ts=true"
import script from "./milestone-carousel.vue?vue&type=script&lang=ts"
export * from "./milestone-carousel.vue?vue&type=script&lang=ts"

import "./milestone-carousel.vue?vue&type=style&index=0&id=1ff765d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff765d0"]])

export default __exports__